
export class Organization {
    id: any;
    catDetCountryId: number;
    flag_url: string;
    organizationId: string;
    name: string;
    participateAvelon: Number = 0;
    countryCode: string;
    tenantId: number = 0;
}